module.exports = __webpack_public_path__ + "media/components/Influencers/Shared/SocialNetworkIcon/instagram-173b6a840cf6227ffbd51b568ff0aa6f.png";